(function () {
  'use strict';

  var PDP_SELECTOR = '[data-section-type="product-template"]';
  var QV_SELECTOR = '[data-quick-view-inner]';

  function init() {
    document.querySelectorAll(PDP_SELECTOR).forEach(function (section) {
      initSection(section);
    });
  }

  function initSection(section) {
    var sectionId = section.getAttribute('data-section-id');
    var jsonEl = document.getElementById('ProductJson-' + sectionId);
    if (!jsonEl) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    if (!product.variants || product.variants.length <= 1) return;

    var selectorsEl = section.querySelector('[data-variant-tile-images]');
    var tileMode = selectorsEl ? selectorsEl.getAttribute('data-variant-tile-images') : 'full';
    var placeholderSrc = selectorsEl ? selectorsEl.getAttribute('data-variant-tile-placeholder') : null;

    var state = {
      product: product,
      sectionId: sectionId,
      section: section,
      currentVariant: getInitialVariant(product),
      tileMode: tileMode,
      placeholderSrc: placeholderSrc
    };

    observeVariantChanges(state);
    updateSelectorImages(state);
  }

  function getInitialVariant(product) {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (variantId) {
      var found = product.variants.find(function (v) {
        return String(v.id) === variantId;
      });
      if (found) return found;
    }
    return product.variants.find(function (v) { return v.available; }) || product.variants[0];
  }

  function observeVariantChanges(state) {
    var hiddenInput = state.section.querySelector('input[name="id"][data-product-select]');
    if (!hiddenInput) return;

    function handleVariantChange() {
      var variantId = hiddenInput.value;
      if (String(state.currentVariant.id) === String(variantId)) return;

      var variant = state.product.variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!variant) return;

      state.currentVariant = variant;
      updateSelectorImages(state);
      state.section.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: variant, product: state.product }
      }));
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'value') {
          handleVariantChange();
        }
      });
    });
    observer.observe(hiddenInput, { attributes: true, attributeFilter: ['value'] });
    hiddenInput.addEventListener('change', handleVariantChange);
  }

  function updateSelectorImages(state) {
    var variant = state.currentVariant;
    if (!variant) return;
    if (state.tileMode === 'none') return;

    var optionContainers = state.section.querySelectorAll('[data-option-position]');
    optionContainers.forEach(function (container) {
      var position = parseInt(container.getAttribute('data-option-position'), 10);
      if (state.tileMode === 'first' && position > 1) return;
      var optionIndex = position - 1;

      container.querySelectorAll('[data-option-value]').forEach(function (item) {
        var imgEl = item.querySelector('[data-option-image] img');
        if (!imgEl) return;

        var testValue = item.getAttribute('data-option-value');
        var matchVariant = state.product.variants.find(function (v) {
          if (v.options[optionIndex] !== testValue) return false;
          return state.product.options.every(function (optName, oi) {
            if (oi === optionIndex) return true;
            return v.options[oi] === variant.options[oi];
          });
        });

        if (matchVariant && matchVariant.featured_image) {
          var newSrc = matchVariant.featured_image.src;
          if (newSrc.indexOf('?') > -1) {
            newSrc = newSrc.split('?')[0];
          }
          imgEl.src = newSrc + '?width=100&height=100';
          imgEl.alt = testValue;
          imgEl.style.display = '';
          imgEl.classList.remove('image--placeholder');
        } else if (state.placeholderSrc) {
          imgEl.src = state.placeholderSrc;
          imgEl.alt = testValue;
          imgEl.style.display = '';
          imgEl.classList.add('image--placeholder');
        } else {
          imgEl.style.display = 'none';
        }
      });
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var value = '';
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  // Update price, compare-at price and savings for the selected variant.
  // theme.js only drives these hooks via the Dawn <variant-selects> element;
  // the PDP uses the legacy radio/swatch picker, so we update them here off
  // the variant:change event that this script already dispatches.
  function updatePrices(scope, variant) {
    if (!scope || !scope.querySelectorAll || !variant) return;

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var saveCents = onSale ? variant.compare_at_price - variant.price : 0;
    var percent = onSale ? Math.round((saveCents * 100) / variant.compare_at_price) : 0;

    scope.querySelectorAll('[data-price-wrapper]').forEach(function (wrap) {
      var priceEl = wrap.querySelector('[data-product-price]');
      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price);
        priceEl.classList.toggle('product__price--sale', !!onSale);
      }
      var compareEl = wrap.querySelector('[data-compare-price]');
      if (compareEl) {
        compareEl.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
      }
    });

    scope.querySelectorAll('[data-price-off]').forEach(function (off) {
      if (!onSale) {
        off.classList.add('hidden');
        return;
      }
      var moneyEl = off.querySelector('[data-price-off-money]');
      if (moneyEl) moneyEl.innerHTML = formatMoney(saveCents);
      var pctEl = off.querySelector('[data-price-off-amount]');
      if (pctEl) pctEl.innerHTML = percent + '%';
      off.classList.remove('hidden');
    });
  }

  function initPriceListener() {
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var scope = e.target && e.target.querySelectorAll ? e.target : document;
      updatePrices(scope, e.detail.variant);
    });
  }

  function initAccordionListener() {
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail.variant;
      if (!variant) return;

      // Resolve each accordion independently so a variant that only overrides
      // one section (e.g. product info) doesn't suppress another section's
      // product-level fallback (e.g. nutrition or shipping).
      var accordions = document.querySelectorAll('.product__accordion');
      accordions.forEach(function (accordion) {
        var items = accordion.querySelectorAll('.accordion-variant-content[data-accordion-variant-id]');
        if (items.length === 0) return;

        var hasMatch = false;
        items.forEach(function (item) {
          var vid = item.getAttribute('data-accordion-variant-id');
          if (String(vid) === String(variant.id)) {
            item.style.display = '';
            hasMatch = true;
          } else {
            item.style.display = 'none';
          }
        });

        if (!hasMatch) {
          items.forEach(function (item) {
            if (item.getAttribute('data-accordion-variant-id') === 'product-fallback') {
              item.style.display = '';
            }
          });
        }
      });
    });
  }

  // Generic per-group variant content swap.
  // Each [data-variant-content-group] is resolved independently: show the
  // child whose [data-variant-content] matches the selected variant id, or the
  // "product-fallback" child if that variant has no value of its own.
  function resolveVariantContentGroup(group, variantId) {
    var items = group.querySelectorAll('[data-variant-content]');
    if (items.length === 0) return;

    var matched = false;
    items.forEach(function (item) {
      if (item.getAttribute('data-variant-content') === String(variantId)) {
        item.style.display = '';
        matched = true;
      } else {
        item.style.display = 'none';
      }
    });

    var hasFallback = false;
    items.forEach(function (item) {
      if (item.getAttribute('data-variant-content') === 'product-fallback') {
        item.style.display = matched ? 'none' : '';
        if (!matched) hasFallback = true;
      }
    });

    var showDisplay = group.dataset.displayDefault || '';
    group.style.display = (matched || hasFallback) ? showDisplay : 'none';
  }

  function initVariantContentGroups() {
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      document.querySelectorAll('[data-variant-content-group]').forEach(function (group) {
        resolveVariantContentGroup(group, e.detail.variant.id);
      });
    });
  }

  // Upsell is a Flickity carousel, which snapshots its cells on init, so we
  // can't just hide/show slides. Instead the active variant's cells live in the
  // slider and the rest sit in a hidden store; on variant change we replace the
  // variant cells (everything after the static merchandiser cells) and tell
  // Flickity to reload.
  function initUpsellListener() {
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      var variantId = e.detail.variant.id;

      document.querySelectorAll('[data-upsell-variant-store]').forEach(function (store) {
        var block = store.closest('.upsell__products');
        if (!block) return;
        var slider = block.querySelector('[data-upsell-slider]');
        if (!slider) return;

        var staticCount = parseInt(slider.getAttribute('data-upsell-static-count') || '0', 10);
        var source = store.querySelector('[data-upsell-variant="' + variantId + '"]')
          || store.querySelector('[data-upsell-variant="product-fallback"]');

        // Build the replacement cells (cloned from the hidden store).
        var newCells = [];
        if (source) {
          source.querySelectorAll(':scope > [data-upsell-holder]').forEach(function (holder) {
            newCells.push(holder.cloneNode(true));
          });
        }

        var Flickity = window.themeVendor && window.themeVendor.Flickity;
        var flkty = Flickity && Flickity.data ? Flickity.data(slider) : null;

        if (flkty) {
          // Flickity reparents cells into its own track, so use its API.
          var cellEls = flkty.getCellElements();
          var toRemove = cellEls.slice(staticCount);
          if (toRemove.length) flkty.remove(toRemove);
          if (newCells.length) flkty.append(newCells);
          flkty.select(0, false, true);
          flkty.resize();
        } else {
          // No carousel: cells are direct children of the slider.
          var holders = Array.prototype.slice.call(slider.querySelectorAll(':scope > [data-upsell-holder]'));
          for (var i = staticCount; i < holders.length; i++) {
            holders[i].remove();
          }
          newCells.forEach(function (cell) {
            slider.appendChild(cell);
          });
        }
      });
    });
  }

  function initVariantBoxListener() {
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail.variant;
      if (!variant) return;

      var boxItems = document.querySelectorAll('.variant-box-item[data-variant-id]');
      if (boxItems.length === 0) return;

      var hasMatch = false;
      boxItems.forEach(function (item) {
        var vid = item.getAttribute('data-variant-id');
        if (String(vid) === String(variant.id)) {
          item.style.display = '';
          hasMatch = true;
          item.querySelectorAll('.box-item').forEach(function (box, i) {
            if (i < 8) {
              box.style.display = '';
              var img = box.querySelector('.box-image img');
              if (img && img.getAttribute('data-src')) {
                img.src = img.getAttribute('data-src');
              }
            }
          });
          var showBtn = item.querySelector('.show-all-button');
          if (showBtn) showBtn.style.display = '';
          var hideBtn = item.querySelector('.hide-all-button');
          if (hideBtn) hideBtn.style.display = 'none';
        } else {
          item.style.display = 'none';
        }
      });

      var section = document.querySelector('[data-section-type="variant-box"]');
      if (!hasMatch) {
        var fallback = document.querySelector('.variant-box-item[data-variant-id="product-fallback"]');
        if (fallback) {
          fallback.style.display = '';
        } else if (section) {
          section.style.display = 'none';
        }
      } else if (section) {
        section.style.display = '';
      }
    });
  }

  function observeQuickView() {
    var qvObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var qvInner = node.matches && node.matches(QV_SELECTOR) ? node : node.querySelector(QV_SELECTOR);
          if (qvInner) {
            initSection(qvInner);
          }
        });
      });
    });
    qvObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initPopupGuard() {
    function hasPopupContent() {
      var popup = document.querySelector('.product-info-popup');
      if (!popup) return false;
      return !!popup.querySelector('.info-popup-inner:not([style*="display: none"])');
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.discount')) return;
      if (!hasPopupContent()) e.stopImmediatePropagation();
    }, true);

    document.addEventListener('variant:change', function () {
      var discount = document.querySelector('.text-with-icon.discount');
      if (discount) {
        discount.style.cursor = hasPopupContent() ? '' : 'default';
      }
    });
  }

  function initAtcStateListener() {
    var labels = {
      preorder: (window.theme && window.theme.strings && window.theme.strings.preorder) || 'Pre-order',
      available: (window.theme && window.theme.strings && window.theme.strings.add_to_cart) || 'Add to cart',
      soldout_online: 'SOLD OUT ONLINE',
      unavailable: (window.theme && window.theme.strings && window.theme.strings.sold_out) || 'Sold out'
    };

    function getVariantPrice(scope, variantId) {
      var sectionId = scope.getAttribute('data-section-id');
      if (!sectionId) return '';
      var jsonEl = document.getElementById('ProductJson-' + sectionId);
      if (!jsonEl) return '';
      try {
        var product = JSON.parse(jsonEl.textContent);
        var variant = product.variants.find(function (v) {
          return String(v.id) === String(variantId);
        });
        return variant ? formatMoney(variant.price) : '';
      } catch (e) {
        return '';
      }
    }

    function ensurePrice(btn, priceStr) {
      if (!priceStr || btn.querySelector('[data-money-convertible]')) return;
      var sep = document.createElement('span');
      sep.className = 'Button__SeparatorDot';
      sep.style.margin = '0 0.5em';
      sep.textContent = '—';
      var price = document.createElement('span');
      price.setAttribute('data-money-convertible', '');
      price.textContent = priceStr;
      var loader = btn.querySelector('.loader');
      if (loader) {
        btn.insertBefore(sep, loader);
        btn.insertBefore(price, loader);
      } else {
        btn.appendChild(sep);
        btn.appendChild(price);
      }
    }

    function getAtcScope(mapEl) {
      return mapEl.closest('[data-section-type="product-template"], [data-quick-view-inner]');
    }

    function applyAtcState(scope, variantId) {
      if (!scope) return;
      var mapEl = scope.querySelector('[data-variant-atc-states]');
      if (!mapEl) return;

      var map;
      try {
        map = JSON.parse(mapEl.textContent);
      } catch (e) {
        return;
      }

      var entry = map[String(variantId)];
      if (!entry) return;

      var state = entry.state;
      var disabled = state === 'soldout_online' || state === 'unavailable';
      var label = labels[state] || labels.available;
      var priceStr = disabled ? '' : getVariantPrice(scope, variantId);

      scope.querySelectorAll('.product__submit__add[data-add-to-cart]').forEach(function (btn) {
        if (btn.matches('[data-upsell-button]')) return;

        var textEl = btn.querySelector('[data-add-to-cart-text]');
        if (textEl) textEl.textContent = label;

        if (disabled) {
          btn.setAttribute('disabled', 'disabled');
          btn.querySelectorAll('.Button__SeparatorDot').forEach(function (el) { el.remove(); });
          btn.querySelectorAll('[data-money-convertible]').forEach(function (el) { el.remove(); });
        } else {
          btn.removeAttribute('disabled');
          ensurePrice(btn, priceStr);
          var priceEl = btn.querySelector('[data-money-convertible]');
          if (priceEl && priceStr) priceEl.textContent = priceStr;
        }
      });
    }

    function handleVariantAtc(e) {
      if (!e.detail || !e.detail.variant) return;
      var scope = e.target && e.target.querySelector ? e.target : document;
      applyAtcState(scope, e.detail.variant.id);
    }

    document.addEventListener('theme:variant:change', handleVariantAtc);

    setTimeout(function () {
      document.querySelectorAll('[data-variant-atc-states]').forEach(function (mapEl) {
        var scope = getAtcScope(mapEl);
        if (!scope) return;
        var input = scope.querySelector('input[name="id"][data-product-select]');
        if (input && input.value) {
          applyAtcState(scope, input.value);
        }
      });
    }, 0);
  }

  function boot() {
    init();
    initAtcStateListener();
    initPriceListener();
    initVariantContentGroups();
    initUpsellListener();
    initVariantBoxListener();
    initAccordionListener();
    initPopupGuard();
    observeQuickView();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
